import { resolveComponent as o, openBlock as p, createBlock as s, withCtx as e, createVNode as c, renderSlot as i } from "vue";
/* empty css                    */
import m from "./design-system.es128.js";
import a from "./design-system.es37.js";
import d from "./design-system.es62.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
const f = {
  name: "DsMenuFooter",
  components: {
    Box: a,
    Inline: d
  }
};
function l(t, _, u, x, B, $) {
  const n = o("Inline"), r = o("Box");
  return p(), s(r, {
    "padding-y": "spacing-050",
    class: "ds-menu-footer"
  }, {
    default: e(() => [
      c(n, {
        fill: "",
        "align-x": "center"
      }, {
        default: e(() => [
          i(t.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })
    ]),
    _: 3
  });
}
const M = /* @__PURE__ */ m(f, [["render", l], ["__scopeId", "data-v-1042715f"]]);
export {
  M as default
};
//# sourceMappingURL=design-system.es72.js.map
